import { Common, ApiBind } from './common.model';

export class PlacementRelationAdRequestDaily extends Common {

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'current_ecpm' })
  currentECPM: string;

}
